import { render, staticRenderFns } from "./PersonalContactSource.vue?vue&type=template&id=4a6c7945&scoped=true&"
import script from "./PersonalContactSource.vue?vue&type=script&lang=js&"
export * from "./PersonalContactSource.vue?vue&type=script&lang=js&"
import style0 from "./PersonalContactSource.vue?vue&type=style&index=0&id=4a6c7945&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a6c7945",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VCard,VListItem,VListItemContent,VListItemTitle,VSimpleTable})
